<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getBusinessModelClassList_data.bmcName"
          placeholder="请输入筛查题目模块名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getBusinessModelClassList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if='addBusinessModelClass'
          @click=" $form('addBusinessModelClass') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加筛查题目模块
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getBusinessModelClassList'
      api='getBusinessModelClassList'
      updateapi='updateBusinessModelClass'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addBusinessModelClass:    [ "新增筛查题目模块信息", "el-icon-circle-plus" ],
        updateBusinessModelClass: [ "修改筛查题目模块信息", "el-icon-edit-outline"],
        $succeed$: getBusinessModelClassList
      }'
      @close='$form("addBusinessModelClass","reset")' >
      <hide slot='bmcId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bmcId: null,

      tableColums_getBusinessModelClassList: {
        $selection: false,

        bmcName: '筛查题目模块名称',

        $operation: [
          '操作', 200,
          this.updateBusinessModelClass && `@text: 编辑#success
           @click: $form("updateBusinessModelClass",$row)
          `,
          this.deleteBusinessModelClass && `@text: 删除#danger
           @click: _confirm('确定要删除该筛查题目模块吗?')
                   .trigger('deleteBusinessModelClass',{bmcId:$row.bmcId})
                   .trigger('getBusinessModelClassList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getBusinessModelClassList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/BusinessModelClassManage.vue